import { css } from 'styled-components';
import { theme } from "../../theme";
import { isShowingScrollbars } from "../../utils/scrollbar-width";
/**
 * We are creating some default coloring for scrollbars
 * when OS X and Edge have auto show scrollbars when a
 * mouse is present. There are several issues which
 * occur already with respect to sizing divs with scrollbars
 * but the light colored scroll bars are a huge problem.
 * We are waiting for Chrome/Safari etc to respect the
 * `scrollbar-color: dark` feature
 */

var shouldStyleScrollbars = isShowingScrollbars();
export var darkScrollbarStyles = css(["scrollbar-width:thin;scrollbar-color:", " transparent;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar;", ""], theme.colors.palette.whiteA20, function () {
  if (shouldStyleScrollbars) {
    return css(["&::-webkit-scrollbar{width:", ";height:", ";}&::-webkit-scrollbar-button,&::-webkit-scrollbar-corner,&::-webkit-scrollbar-track,&::-webkit-scrollbar-track-piece{background-color:transparent;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:", ";border:3px solid transparent;background-clip:content-box;&:active,&:focus,&:hover{visibility:visible;background-color:", ";}}"], theme.spaces[12], theme.spaces[12], theme.colors.palette.whiteA20, theme.radii[8], theme.colors.palette.whiteA60);
  }

  return css([""]);
});